// extracted by mini-css-extract-plugin
export default {"header":"MainPage_header__cf8ci","carousel":"MainPage_carousel__NuBQC"};